import type { PortalRole } from '@/hooks/useResolvedRole';

// patient.rxfoodapp.com, stg-patient.rxdev.co, patient-us.rxfoodapp.com and
// stg-patient-us.rxdev.co (FOOD-1073). Also matches patient.localhost for local testing.
const PATIENT_HOST = /^(stg-)?patient(-us)?\./;

/**
 * Whether the request host is a dedicated patient-portal hostname.
 * Unlike `servesPortal('patient')`, this is false on localhost under the
 * dev server — use it for patient-only chrome/copy (e.g. login wording).
 */
export const isPatientHost = (
  hostname: string = window.location.hostname,
): boolean => PATIENT_HOST.test(hostname);

/**
 * Whether this host serves a portal's routes. A patient host serves only the
 * patient portal and every other host only the clinician portal, so a patient
 * link never opens on a clinician origin or the reverse. The dev server keeps
 * both on localhost so local work needs no special hostname.
 */
export const servesPortal = (
  portal: PortalRole,
  hostname: string = window.location.hostname,
  isDevServer: boolean = import.meta.env.DEV,
): boolean => {
  if (isPatientHost(hostname)) return portal === 'patient';
  return portal === 'clinician' || isDevServer;
};
